import type { ClientFilters, ClientFormState, ClientStatus, CreditDocumentChecklist } from './types';

export const clientStatusOptions: Array<{ label: string; value: ClientStatus }> = [
  { label: 'Activo', value: 'ACTIVE' },
  { label: 'Observado', value: 'WATCHLIST' },
  { label: 'Bloqueado', value: 'BLOCKED' },
  { label: 'Inactivo', value: 'INACTIVE' },
];

export const initialClientForm: ClientFormState = {
  referenceName: '',
  personalAddressReference: '',
  businessAddressReference: '',
  referencePhone: '',
  hasSpouse: false,
  spouseFullName: '',
  spousePhone: '',
  hasGuarantor: false,
  guarantorFullName: '',
  guarantorPhone: '',
  businessRuc: '',
  businessName: '',
  businessPhone: '',
  businessActivity: '',
  department: '',
  province: '',
  district: '',
  dni: '',
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  personalAddress: '',
  businessAddress: '',
  birthDate: '',
  isSpecial: false,
  specialInterestRate: '',
  status: 'ACTIVE',
};

export const initialClientFilters: ClientFilters = {
  dni: '',
  name: '',
};

export const initialCreditDocumentChecklist: CreditDocumentChecklist = {
  contract: false,
  disbursementRequest: false,
  schedule: false,
};
